export default "__VITE_ASSET__B6yzH357__"